import { createContext } from "react";

export const Product = createContext({
  product: {},
  addedToCart:false,
  selectedVendor: {},
  shoppingCartProducts:[],
  addToCart: () => undefined,
  removeFromCart: () => undefined,
});